module.exports = __webpack_public_path__ + "media/bgm_battle.e147d26f.mp3";